import { z } from 'zod';
/**
 * Entidades financieras colombianas con su código de compensación (usado como código de
 * participante Bre-B en el demo). La entidad del demo es ficticia: ver `DEMO_ENTITY`.
 */
export const PARTICIPANT_TYPES = ['BANK', 'SEDPE', 'COOP', 'CF'];
export const ParticipantTypeSchema = z.enum(PARTICIPANT_TYPES);
export const BANKS = [
    { code: '01', name: 'BANCO DE BOGOTA', type: 'BANK' },
    { code: '02', name: 'BANCO POPULAR', type: 'BANK' },
    { code: '06', name: 'ITAU', type: 'BANK' },
    { code: '07', name: 'BANCOLOMBIA', type: 'BANK' },
    { code: '09', name: 'CITIBANK', type: 'BANK' },
    { code: '12', name: 'BANCO GNB SUDAMERIS', type: 'BANK' },
    { code: '13', name: 'BBVA COLOMBIA', type: 'BANK' },
    { code: '19', name: 'SCOTIABANK COLPATRIA S.A', type: 'BANK' },
    { code: '21', name: 'FINANCIERA JURISCOOP S.A. COMPANIA DE FINANCIAMIENTO', type: 'CF' },
    { code: '23', name: 'BANCO DE OCCIDENTE', type: 'BANK' },
    { code: '31', name: 'BANCOLDEX S.A.', type: 'BANK' },
    { code: '32', name: 'BANCO CAJA SOCIAL BCSC SA', type: 'BANK' },
    { code: '37', name: 'IRIS', type: 'CF' },
    { code: '39', name: 'COLTEFINANCIERA S.A', type: 'CF' },
    { code: '40', name: 'BANCO AGRARIO', type: 'BANK' },
    { code: '41', name: 'MOVII', type: 'SEDPE' },
    { code: '47', name: 'BANCO MUNDO MUJER', type: 'BANK' },
    { code: '51', name: 'BANCO DAVIVIENDA SA', type: 'BANK' },
    { code: '52', name: 'BANCO AV VILLAS', type: 'BANK' },
    { code: '53', name: 'BANCO W S.A.', type: 'BANK' },
    { code: '58', name: 'BANCO CREDIFINANCIERA SA.', type: 'BANK' },
    { code: '59', name: 'BANCO DE LAS MICROFINANZAS - BANCAMIA S.A.', type: 'BANK' },
    { code: '60', name: 'BANCO PICHINCHA', type: 'BANK' },
    { code: '61', name: 'BANCOOMEVA', type: 'BANK' },
    { code: '62', name: 'BANCO FALABELLA S.A.', type: 'BANK' },
    { code: '63', name: 'BANCO FINANDINA S.A.', type: 'BANK' },
    { code: '65', name: 'BANCO SANTANDER DE NEGOCIOS COLOMBIA S.A', type: 'BANK' },
    { code: '66', name: 'BANCO COOPERATIVO COOPCENTRAL', type: 'BANK' },
    { code: '67', name: 'MIBANCO S.A.', type: 'BANK' },
    { code: '69', name: 'BANCO SERFINANZA S.A', type: 'BANK' },
    { code: '70', name: 'LULO BANK S.A.', type: 'BANK' },
    { code: '71', name: 'BANCO J.P. MORGAN COLOMBIA S.A.', type: 'BANK' },
    { code: '73', name: 'BANCO UNION S.A', type: 'BANK' },
    { code: '81', name: 'RAPPIPAY', type: 'SEDPE' },
    { code: '82', name: 'DING TECNIPAGOS SA', type: 'SEDPE' },
    { code: '83', name: 'COOPERATIVA FINANCIERA DE ANTIOQUIA', type: 'COOP' },
    { code: '84', name: 'UALA', type: 'SEDPE' },
    { code: '85', name: 'BANCO BTG PACTUAL', type: 'BANK' },
    { code: '86', name: 'JFK COOPERATIVA FINANCIERA', type: 'COOP' },
    { code: '89', name: 'COOTRAFA COOPERATIVA FINANCIERA', type: 'COOP' },
    { code: '91', name: 'DAVIPLATA', type: 'SEDPE' },
    { code: '92', name: 'CONFIAR COOPERATIVA FINANCIERA', type: 'COOP' },
    { code: '98', name: 'ASOPAGOS S.A.S', type: 'SEDPE' },
    { code: '99', name: 'COOFINEP COOPERATIVA FINANCIERA', type: 'COOP' },
    { code: '1507', name: 'NEQUI', type: 'SEDPE' },
    /** Entidad ficticia del demo (marca blanca); no existe en el catálogo real. */
    { code: '990', name: 'BANCO ALIADO S.A.', type: 'BANK' },
];
/**
 * Entidad financiera del demo (ficticia, marca blanca). Es el **único lugar** donde se nombra: semillas,
 * textos de agentes, KB y UI la toman de aquí. Para presentar a otra entidad se cambia este objeto
 * (y, en un tenant real, `TenantSettings.displayName` / `participantCode`).
 */
export const DEMO_ENTITY = {
    /** Nombre comercial que ve el cliente ("asesor de Banco Aliado"). */
    name: 'Banco Aliado',
    /** Razón social (comprobantes, extractos, movimientos Bre-B). */
    legalName: 'BANCO ALIADO S.A.',
    participantCode: '990',
};
export const BankCodeSchema = z.enum(BANKS.map((b) => b.code));
const BANKS_BY_CODE = new Map(BANKS.map((b) => [b.code, b]));
export function findBank(code) {
    return BANKS_BY_CODE.get(code);
}
/** Tipos de cuenta de depósito (código ACH → etiqueta). */
export const DEPOSIT_ACCOUNT_TYPES = [
    { code: 'SAVINGS', achCode: '7', label: 'Cuenta de Ahorros' },
    { code: 'CHECKING', achCode: '1', label: 'Cuenta Corriente' },
    { code: 'ELECTRONIC_DEPOSIT', achCode: '9', label: 'Depósito Electrónico' },
];
export const DepositAccountTypeSchema = z.enum(['SAVINGS', 'CHECKING', 'ELECTRONIC_DEPOSIT']);
//# sourceMappingURL=banks.js.map